export default "__VITE_ASSET__BhCNFHyl__"